namespace Serenity {
    export interface ServiceError {
        Code?: string;
        Arguments?: string;
        Message?: string;
    }
}